var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBarSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6838 14.7113C15.0059 14.3913 15.5222 14.3913 15.8443 14.7113L17.9732 16.4297H18.0101C18.4408 16.865 18.4408 17.5708 18.0101 18.0062C17.5794 18.4415 16.8811 18.4415 16.4504 18.0062L14.6838 15.9814L14.6167 15.9058C14.4918 15.7477 14.4229 15.5506 14.4229 15.3463C14.4229 15.108 14.5167 14.8795 14.6838 14.7113ZM8.81454 1.66602C10.7103 1.66602 12.5284 2.42721 13.869 3.78215C15.2095 5.13709 15.9626 6.97478 15.9626 8.89095C15.9626 12.8812 12.7623 16.1159 8.81454 16.1159C4.86679 16.1159 1.6665 12.8812 1.6665 8.89095C1.6665 4.90073 4.86679 1.66602 8.81454 1.66602Z",
    fill: "#310048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBarSearchBlack);
export default __webpack_public_path__ + "static/media/bottom-bar-search-black.264481e6be481b0a24c27cdac0b5069e.svg";
export { ForwardRef as ReactComponent };